// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"68":"ed0057e4","85":"eb01860d","127":"d260de65","136":"6716f862","152":"44b77832","285":"5f735a03","309":"405205c6","381":"013fbb0d","621":"0adc13f1","645":"3e735a6f","810":"1a2a1427"}[chunkId] + ".chunk.css";
};